/**
 * Slide toggle (black thumb, grey bar): a native checkbox exposed as a switch,
 * so the label, keyboard and screen readers work by construction.
 */
import type { ReactNode } from 'react';

export interface SlideToggleProps {
  id: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
  className?: string;
  testId?: string | undefined;
}

export function SlideToggle({
  id,
  checked,
  disabled = false,
  onChange,
  children,
  className = '',
  testId,
}: Readonly<SlideToggleProps>) {
  return (
    <label className={`slide-toggle ${className}`} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        data-testid={testId}
      />
      <span className="slide-toggle-bar" aria-hidden="true">
        <span className="slide-toggle-thumb" />
      </span>
      <span className="slide-toggle-label">{children}</span>
    </label>
  );
}
